import { useLayoutEffect, useRef } from "react";

// Anima o conteúdo sem remontar a página, perder formulários ou criar cópias da mídia.
export function useRouteTransition(pathname: string, navigating: boolean) {
  const content = useRef<HTMLDivElement>(null);
  const previousPathname = useRef(pathname);

  useLayoutEffect(() => {
    if (navigating || previousPathname.current === pathname) return;
    previousPathname.current = pathname;
    const element = content.current;
    if (
      !element ||
      typeof element.animate !== "function" ||
      typeof window.matchMedia !== "function"
    )
      return;
    const preference = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (preference.matches) return;

    const animation = element.animate(
      [
        { opacity: 0.3, transform: "translateY(6px)" },
        { opacity: 1, transform: "translateY(0)" },
      ],
      { duration: 220, easing: "cubic-bezier(0.22, 1, 0.36, 1)" },
    );
    const stop = () => animation.cancel();
    preference.addEventListener("change", stop);
    return () => {
      preference.removeEventListener("change", stop);
      stop();
    };
  }, [pathname, navigating]);

  return content;
}
